import { useState } from "react";
import { categories, mangaList } from "@/mocks/manga";

export default function Category() {
  const [active, setActive] = useState("全部");

  const cats = ["全部", ...categories.map((c) => c.name)];
  const filtered =
    active === "全部" ? mangaList : mangaList.filter((m) => m.category === active);

  return (
    <section id="category" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-4 py-1.5 text-sm font-medium text-primary-500">
            <i className="ri-layout-grid-line"></i>
            题材全覆盖
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            题材分类
          </h2>
          <p className="mt-3 max-w-xl text-base text-foreground-700">
            异世界、魔法、脑洞、冒险……点开即看，总有一款奇幻剧情让你上瘾。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#category"
              onClick={(e) => {
                e.preventDefault();
                setActive(c.name);
              }}
              className="group relative overflow-hidden rounded-xl border border-background-200/70"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name}漫画分类`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                    <i className={`${c.icon} text-primary-500`}></i>
                    {c.name}
                    <span className="text-xs font-normal text-foreground-600">{c.count} 部</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-700">{c.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors whitespace-nowrap ${
                active === c
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:text-primary-500"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {filtered.map((m) => (
            <article
              key={m.id}
              className="group overflow-hidden rounded-xl border border-background-200/70 bg-background-100/50"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={m.cover}
                  alt={`${m.name}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 rounded-md bg-background-950/70 px-2 py-0.5 text-xs text-primary-400 backdrop-blur">
                  {m.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 group-hover:text-primary-500">
                  {m.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-600">{m.chapter}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}